export default __webpack_public_path__ + "static/media/philips.d8270d06.svg";